<template><!--个人中心》我的钱包》余额明细-->
    <div class="balancesDetails">
        余额明细,开发中
    </div>
</template>

<style scoped>
   
</style>

<script>
    export default
    {
        name: 'balancesDetails',
        props: { parentName: { type: Object } },
        data()
        {
            return {



                //+--------------------------------------------------------
                bol: false,
            };
        },
        created()
        {

        },
        methods:
        {


            // +--------------------------------------
            closeClick()
            {
                this.$emit( 'childFn', this.bol )
            }

        }
    }
</script>